var _style, _g, _polygon, _path, _g2, _polygon2, _path2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOptiLynx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 384",
    style: {
      enableBackground: "new 0 0 1000 384"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4D4D4D;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_2_);}\n\t.st3{fill:url(#SVGID_3_);}\n\t.st4{fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M967.8,43.9H962v16.7h-4.6V43.9h-5.8v-3.8h16.3V43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M993.9,60.7h-4.6V48.4c0-1.3,0.1-2.8,0.2-4.4h-0.1c-0.2,1.3-0.5,2.2-0.6,2.7L984,60.7h-3.8l-4.9-13.8 c-0.1-0.4-0.3-1.3-0.6-2.9h-0.1c0.1,2,0.2,3.8,0.2,5.3v11.3h-4.2V40.2h6.8l4.2,12.1c0.3,1,0.6,1.9,0.7,2.9h0.1 c0.3-1.1,0.5-2.1,0.8-3l4.2-12.1h6.6V60.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 533.0286,
    y1: 284.6058,
    x2: 533.0286,
    y2: 9.2604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F7EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#26A2FF"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "604.8,187.6 518.5,187.6 548.2,9.9 497.8,9.9 461.2,229.2 597.9,229.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.8431,
    y1: 284.6058,
    x2: 777.8431,
    y2: 9.2604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0F7EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#26A2FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M995,65.9h-42.2l-34.1,47.8l-20.5-47.8h-52.1l35.7,75.8l-49.4,63.6l11.4-67.9c2.5-15.1,3.7-25.2,3.7-30.4 c0-12.7-4-23.3-12.1-31.6c-8.1-8.3-18.6-12.5-31.5-12.5c-20.8,0-37.2,11.3-49.1,33.9l5.2-31h-31.8h-12.5h-24.6l-44,99.3 l-19.8-99.3H578l37.6,161.5c-2.9,8.6-6.7,14.7-11.3,18.1c-4.7,3.5-11.7,5.2-21,5.2c-4.1,0-10.8-0.6-20.1-1.8l-2.6,36.6 c4,0.5,9.7,0.8,17.1,0.8c15,0,26.6-2.2,34.9-6.5c8.3-4.3,15-10.2,20.1-17.7c5.1-7.4,12.6-21.4,22.3-42l53.9-113.5l-20.5,122.7 h47.2l13.5-80.8c2.1-13.1,4.3-22.7,6.6-28.8c2.2-6.2,5.8-11.2,10.8-15.1c4.9-3.9,10.3-5.9,16.2-5.9c11.2,0,16.9,5.7,16.9,17.2 c0,2.5-0.8,8.5-2.4,18l-15.9,95.4h32.5h14.6h27.2l41.7-57.8l23.9,57.8H972l-38.9-85.4L995,65.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "547.9,11.6 548.2,9.9 497.8,9.9 461.2,229.2 463.1,229.2 499.5,11.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604.6,189.3 604.8,187.6 520.4,187.6 520.1,189.3  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.6,64.6c12.2,0,22.3,3.8,30.2,11.2c-0.1-0.1-0.3-0.3-0.4-0.4c-8.1-8.3-18.6-12.5-31.5-12.5 c-19.3,0-34.7,9.7-46.4,29.1l-1.1,6.5C768.4,75.9,784.8,64.6,805.6,64.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "954.5,67.5 993.7,67.5 995,65.9 952.8,65.9 919.3,112.8 920.4,115.3  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585,252.3c9.3,0,16.3-1.7,21-5.2c4.7-3.5,8.4-9.5,11.3-18.1L579.7,67.5h48l-0.3-1.6H578l37.6,161.5 c-2.9,8.6-6.7,14.7-11.3,18.1c-4.7,3.5-11.7,5.2-21,5.2c-4.1,0-10.8-0.6-20.1-1.8l-2.6,36.6c0.5,0.1,1.1,0.1,1.7,0.2l2.5-35.2 C574.2,251.7,580.9,252.3,585,252.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "883.4,143.3 847.7,67.5 898.9,67.5 898.2,65.9 846.1,65.9 881.8,141.7 834.9,202.1 834.1,206.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "692.8,67.5 717.4,67.5 729.9,67.5 759.8,67.5 760,65.9 728.3,65.9 715.7,65.9 691.2,65.9 648.1,163.1  648.9,166.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "898.3,174 921.1,229.2 922.1,229.2 898.9,173.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.3,117.5c0-6.4-1.7-11-5.2-13.8c2.4,2.8,3.6,6.9,3.6,12.1c0,2.5-0.8,8.5-2.4,18l-15.9,95.4h1.9l15.6-93.8 C800.5,125.9,801.3,119.9,801.3,117.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "707.6,114.5 688.4,229.2 690.4,229.2 710.6,108.2  "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 518.5,
    y1: 187.6,
    x2: 520.4,
    y2: 187.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 549.8,
    y1: 11.6,
    x2: 547.9,
    y2: 11.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 463.1,
    y1: 229.2,
    x2: 462.9,
    y2: 230.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.9,229.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.6,230.9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 647.2,
    y1: 165.1,
    x2: 648.1,
    y2: 163.1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 629,
    y1: 67.5,
    x2: 627.7,
    y2: 67.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 707.6,
    y1: 114.5,
    x2: 708.9,
    y2: 106.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.5025,
    y1: 284.6058,
    x2: 461.5025,
    y2: 11.3677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02030F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E5DB5"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "440.8,7.1 433,53.5 482.2,53.5 490,7.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.576,
    y1: 284.6058,
    x2: 242.576,
    y2: 11.3677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02030F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4E5DB5"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M431,65.9h-31.1l7.9-46.1l-41.4,1.1l-11.1,45H328l-3.3,19.8c-0.8-1.2-1.6-2.4-2.4-3.6 c-9-12.3-21.5-18.5-37.5-18.5c-18.2,0-33.2,10.6-45.1,31.7l4.9-29.4h-42.9l-6.8,40.7c0-1.2,0.1-2.3,0.1-3.5 c0-29.1-7.8-52.5-23.5-70.2c-15.7-17.7-36.9-26.5-63.5-26.5c-31.1,0-56,13.1-74.7,39.4C14.4,72,5,102.5,5,137.2 c0,28.7,7.9,51.8,23.7,69.2c15.8,17.5,36.7,26.2,62.6,26.2c31.8,0,57-12.8,75.7-38.3c8.4-11.5,14.8-23.9,19.5-37.4l-21.7,129.3 H212l13.4-81c2.6,7.9,7.7,14.5,15.3,19.6c7.7,5.1,16.4,7.7,26.3,7.7c19.9,0,36.4-10.1,49.4-30.3c13-20.2,19.5-44,19.5-71.6 c0-10.2-1.2-19.3-3.4-27.5h14.6L336,157c-3.4,17.2-5.1,29.5-5.1,36.8c0,26.3,16.2,39.5,48.7,39.5c10.4,0,21.2-0.9,32.5-2.7 l0.2-1.3h40.6l27.3-163.4h-42.4H431z M132.6,159.6c-8.1,21.7-21.6,32.5-40.5,32.5c-24.4,0-36.6-15.9-36.6-47.6 c0-24.3,4.4-46.7,13.2-67.1c8.8-20.4,21.9-30.6,39.4-30.6c24.5,0,36.8,16.4,36.8,49.1C144.8,116.8,140.7,138,132.6,159.6z  M279.7,173.7c-5.3,17.8-13.9,26.7-25.7,26.7c-6.1,0-11.4-2.5-15.9-7.5c-4.5-5-6.7-12.2-6.7-21.8c0-5.7,1.4-16.6,4.2-32.8 c2.8-16.2,7-27.2,12.7-33c5.7-5.8,11.8-8.8,18.4-8.8c7,0,12.2,2.6,15.7,7.9c3.5,5.2,5.2,11.5,5.2,18.6 C287.6,139,285,155.9,279.7,173.7z M379.9,182.8c0-2.6,0.6-7.2,1.7-14l11-65.5h32.1l-15.4,92.5c-2.5,0.2-5.3,0.2-8.2,0.2 C386.9,196,379.9,191.6,379.9,182.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "440.8,7.1 433,53.5 435,53.5 442.4,8.7 489.7,8.7 490,7.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.7,208.8c1.9,4.2,4.5,8,8,11.3c-3.6-3.8-6.1-8.2-7.7-13.2L226.7,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,104.9h-2L336,157c-3.4,17.2-5.1,29.5-5.1,36.8c0,12.4,3.6,21.8,10.7,28.4c-6-6.5-9.1-15.4-9.1-26.7 c0-7.3,1.7-19.5,5.1-36.8L348.6,104.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.3,195.7c-2.5,0.2-5.3,0.2-8.2,0.2c-7.9,0-13.7-1.4-17.1-4.2c3.2,3.9,9.4,5.8,18.8,5.8c2.9,0,5.7-0.1,8.2-0.2 l15.4-92.5h-1.9L409.3,195.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,286.3h1.9L188,158.6c-1,3-2.2,6-3.4,8.9L164.7,286.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,30.4c-15.4-16-35.8-24-61.2-24c-31.1,0-56,13.1-74.7,39.4C14.4,72,5,102.5,5,137.2c0,28.7,7.9,51.8,23.7,69.2 c1.2,1.4,2.5,2.7,3.8,3.9c-0.7-0.7-1.5-1.5-2.2-2.3c-15.8-17.5-23.7-40.5-23.7-69.2c0-34.7,9.4-65.2,28.1-91.4 C53.5,21.2,78.4,8.1,109.5,8.1C133.9,8.1,153.8,15.5,169,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.7,19.7l-41.4,1.1l-11.1,45H328L324.8,85c0.5,0.8,1,1.5,1.5,2.3l3.3-19.8H357l11.1-45l39.4-1.1L407.7,19.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431,65.9 401.8,65.9 401.5,67.5 432.6,67.5 439.4,67.5 479.9,67.5 480.2,65.9 437.7,65.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4,90.8l-1,6.1c11.9-21.1,26.9-31.7,45.1-31.7c12.7,0,23.3,4,31.6,11.8c-8.6-9-19.7-13.5-33.3-13.5 C268,63.6,253.8,72.7,242.4,90.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6,65.9h-42.9l-5.3,31.7c0.1,2.4,0.2,4.8,0.2,7.2c0,1.2,0,2.3-0.1,3.5l6.8-40.7h41L244.6,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.9,102.5c0.5,0.6,1,1.3,1.5,2c3.5,5.2,5.2,11.5,5.2,18.6c0,16-2.7,32.8-8,50.6c-5.3,17.8-13.9,26.7-25.7,26.7 c-5.3,0-9.9-1.8-13.9-5.5c4.4,4.8,9.6,7.2,15.6,7.2c11.8,0,20.4-8.9,25.7-26.7c5.3-17.8,8-34.6,8-50.6c0-7.2-1.7-13.4-5.2-18.6 C283.1,104.7,282.1,103.5,280.9,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.5,56.7c7.5,8.1,11.3,21.2,11.3,39.3c0,20.8-4.1,42-12.2,63.7c-8.1,21.7-21.6,32.5-40.5,32.5 c-10.2,0-18.2-2.8-24.1-8.3c6.1,6.6,14.6,9.9,25.7,9.9c18.9,0,32.3-10.8,40.5-32.5c8.1-21.7,12.2-42.9,12.2-63.7 C146.4,78.2,142.1,64.6,133.5,56.7z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,379.4v-46.1h15.9c3.6,0,6.3,0.2,8.2,0.7c2.6,0.6,4.9,1.7,6.8,3.3c2.4,2.1,4.2,4.7,5.5,7.9 c1.2,3.2,1.8,6.8,1.8,10.9c0,3.5-0.4,6.6-1.2,9.3c-0.8,2.7-1.9,4.9-3.1,6.7c-1.3,1.8-2.7,3.2-4.2,4.2c-1.5,1-3.4,1.8-5.5,2.3 c-2.1,0.5-4.6,0.8-7.4,0.8H5z M11.1,374h9.8c3,0,5.4-0.3,7.1-0.8s3.1-1.4,4.1-2.4c1.4-1.4,2.6-3.4,3.4-5.8c0.8-2.4,1.2-5.4,1.2-8.9 c0-4.8-0.8-8.5-2.4-11.1c-1.6-2.6-3.5-4.3-5.8-5.2c-1.6-0.6-4.3-0.9-7.9-0.9h-9.7V374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.6,379.4v-46.1h33.3v5.4H57.7v14.1h25.5v5.4H57.7V374H86v5.4H51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.5,379.4l-17.8-46.1h6.6l12,33.5c1,2.7,1.8,5.2,2.4,7.5c0.7-2.5,1.5-5,2.5-7.5l12.4-33.5h6.2l-18,46.1 H107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.3,379.4v-46.1h6.1v46.1H138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188,363.3l6.1,1.5c-1.3,5-3.6,8.8-6.9,11.5c-3.3,2.6-7.4,3.9-12.2,3.9c-5,0-9-1-12.1-3 c-3.1-2-5.5-4.9-7.1-8.8c-1.6-3.8-2.4-7.9-2.4-12.3c0-4.8,0.9-9,2.7-12.6c1.8-3.6,4.4-6.3,7.8-8.1c3.4-1.9,7.1-2.8,11.2-2.8 c4.6,0,8.5,1.2,11.6,3.5c3.1,2.3,5.3,5.6,6.6,9.9l-6,1.4c-1.1-3.4-2.6-5.8-4.6-7.3c-2-1.5-4.6-2.3-7.7-2.3c-3.5,0-6.5,0.8-8.9,2.5 c-2.4,1.7-4,4-5,6.8c-1,2.9-1.4,5.8-1.4,8.8c0,3.9,0.6,7.3,1.7,10.3c1.1,2.9,2.9,5.1,5.3,6.6c2.4,1.4,5,2.2,7.8,2.2 c3.4,0,6.3-1,8.7-3C185.6,370.1,187.2,367.1,188,363.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,379.4v-46.1h33.3v5.4h-27.2v14.1h25.5v5.4h-25.5V374h28.3v5.4H201.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.2,379.4v-46.1h9.2l10.9,32.6c1,3,1.7,5.3,2.2,6.8c0.5-1.7,1.3-4.1,2.5-7.4l11-32h8.2v46.1h-5.9v-38.5 l-13.4,38.5h-5.5l-13.3-39.2v39.2H262.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311,379.4l17.7-46.1h6.6l18.8,46.1h-6.9l-5.4-13.9h-19.3l-5.1,13.9H311z M324.3,360.5h15.6l-4.8-12.8 c-1.5-3.9-2.6-7.1-3.3-9.6c-0.6,3-1.4,5.9-2.5,8.8L324.3,360.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M358.9,379.4v-46.1h6.3l24.2,36.2v-36.2h5.8v46.1h-6.3l-24.2-36.2v36.2H358.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.3,379.4l17.7-46.1h6.6l18.8,46.1h-6.9l-5.4-13.9h-19.3l-5.1,13.9H400.3z M413.6,360.5h15.6l-4.8-12.8 c-1.5-3.9-2.6-7.1-3.3-9.6c-0.6,3-1.4,5.9-2.5,8.8L413.6,360.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M469.9,361.4V356l19.5,0V373c-3,2.4-6.1,4.2-9.3,5.4c-3.2,1.2-6.5,1.8-9.8,1.8c-4.5,0-8.6-1-12.3-2.9 c-3.7-1.9-6.5-4.7-8.4-8.4c-1.9-3.7-2.8-7.8-2.8-12.3c0-4.5,0.9-8.7,2.8-12.6c1.9-3.9,4.6-6.8,8.1-8.7c3.5-1.9,7.6-2.8,12.2-2.8 c3.3,0,6.3,0.5,9,1.6c2.7,1.1,4.8,2.6,6.3,4.5c1.5,1.9,2.7,4.4,3.5,7.5l-5.5,1.5c-0.7-2.3-1.6-4.2-2.6-5.5c-1-1.3-2.5-2.4-4.4-3.2 c-1.9-0.8-4-1.2-6.3-1.2c-2.8,0-5.2,0.4-7.2,1.3c-2,0.8-3.7,2-4.9,3.3c-1.2,1.4-2.2,2.9-2.9,4.6c-1.2,2.8-1.8,5.9-1.8,9.3 c0,4.1,0.7,7.5,2.1,10.3c1.4,2.8,3.5,4.8,6.2,6.2c2.7,1.3,5.6,2,8.6,2c2.6,0,5.2-0.5,7.7-1.5c2.5-1,4.4-2.1,5.7-3.3v-8.6H469.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.5,379.4v-46.1h33.3v5.4h-27.2v14.1h25.5v5.4h-25.5V374h28.3v5.4H498.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.1,379.4v-46.1h9.2l10.9,32.6c1,3,1.7,5.3,2.2,6.8c0.5-1.7,1.3-4.1,2.5-7.4l11-32h8.2v46.1h-5.9v-38.5 l-13.4,38.5h-5.5L547,340.2v39.2H541.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595,379.4v-46.1h33.3v5.4h-27.2v14.1h25.5v5.4h-25.5V374h28.3v5.4H595z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.7,379.4v-46.1h6.3l24.2,36.2v-36.2h5.8v46.1h-6.3l-24.2-36.2v36.2H637.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M696,379.4v-40.6h-15.2v-5.4h36.5v5.4h-15.2v40.6H696z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M738.2,364.6l5.7-0.5c0.3,2.3,0.9,4.2,1.9,5.7c1,1.5,2.5,2.7,4.6,3.6c2.1,0.9,4.5,1.4,7.1,1.4 c2.3,0,4.4-0.3,6.2-1c1.8-0.7,3.1-1.6,4-2.8c0.9-1.2,1.3-2.5,1.3-3.9c0-1.4-0.4-2.7-1.3-3.8c-0.8-1.1-2.2-2-4.1-2.7 c-1.2-0.5-4-1.2-8.2-2.2c-4.2-1-7.2-2-8.9-2.9c-2.2-1.2-3.8-2.6-4.9-4.3c-1.1-1.7-1.6-3.6-1.6-5.7c0-2.3,0.7-4.5,2-6.5 c1.3-2,3.2-3.6,5.8-4.6c2.5-1,5.4-1.6,8.5-1.6c3.4,0,6.4,0.5,9,1.6c2.6,1.1,4.6,2.7,6,4.9c1.4,2.1,2.2,4.6,2.3,7.3l-5.8,0.4 c-0.3-2.9-1.4-5.1-3.2-6.6c-1.8-1.5-4.5-2.2-8-2.2c-3.7,0-6.4,0.7-8.1,2c-1.7,1.4-2.5,3-2.5,4.9c0,1.7,0.6,3,1.8,4.1 c1.2,1.1,4.2,2.2,9.2,3.3c5,1.1,8.4,2.1,10.2,2.9c2.7,1.2,4.7,2.8,5.9,4.7c1.3,1.9,1.9,4.1,1.9,6.6c0,2.5-0.7,4.8-2.1,6.9 c-1.4,2.2-3.4,3.9-6,5.1c-2.6,1.2-5.6,1.8-8.9,1.8c-4.2,0-7.7-0.6-10.5-1.8c-2.8-1.2-5-3-6.6-5.5 C739.1,370.5,738.3,367.7,738.2,364.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M796.2,379.4v-19.5l-17.8-26.5h7.4l9.1,13.9c1.7,2.6,3.2,5.2,4.7,7.8c1.4-2.4,3.1-5.1,5-8.1l8.9-13.5h7.1 l-18.4,26.5v19.5H796.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M824,364.6l5.7-0.5c0.3,2.3,0.9,4.2,1.9,5.7c1,1.5,2.5,2.7,4.6,3.6c2.1,0.9,4.5,1.4,7.1,1.4 c2.3,0,4.4-0.3,6.2-1c1.8-0.7,3.1-1.6,4-2.8c0.9-1.2,1.3-2.5,1.3-3.9c0-1.4-0.4-2.7-1.3-3.8c-0.8-1.1-2.2-2-4.1-2.7 c-1.2-0.5-4-1.2-8.2-2.2c-4.2-1-7.2-2-8.9-2.9c-2.2-1.2-3.8-2.6-4.9-4.3c-1.1-1.7-1.6-3.6-1.6-5.7c0-2.3,0.7-4.5,2-6.5 c1.3-2,3.2-3.6,5.8-4.6c2.5-1,5.4-1.6,8.5-1.6c3.4,0,6.4,0.5,9,1.6c2.6,1.1,4.6,2.7,6,4.9c1.4,2.1,2.2,4.6,2.3,7.3l-5.8,0.4 c-0.3-2.9-1.4-5.1-3.2-6.6c-1.8-1.5-4.5-2.2-8-2.2c-3.7,0-6.4,0.7-8.1,2c-1.7,1.4-2.5,3-2.5,4.9c0,1.7,0.6,3,1.8,4.1 c1.2,1.1,4.2,2.2,9.2,3.3c5,1.1,8.4,2.1,10.2,2.9c2.7,1.2,4.7,2.8,5.9,4.7c1.3,1.9,1.9,4.1,1.9,6.6c0,2.5-0.7,4.8-2.1,6.9 c-1.4,2.2-3.4,3.9-6,5.1c-2.6,1.2-5.6,1.8-8.9,1.8c-4.2,0-7.7-0.6-10.5-1.8c-2.8-1.2-5-3-6.6-5.5C825,370.5,824.1,367.7,824,364.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M880.7,379.4v-40.6h-15.2v-5.4h36.5v5.4h-15.2v40.6H880.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M908.4,379.4v-46.1h33.3v5.4h-27.2v14.1H940v5.4h-25.5V374h28.3v5.4H908.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M951,379.4v-46.1h9.2l10.9,32.6c1,3,1.7,5.3,2.2,6.8c0.5-1.7,1.3-4.1,2.5-7.4l11-32h8.2v46.1h-5.9v-38.5 l-13.4,38.5h-5.5l-13.3-39.2v39.2H951z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptiLynx);
export default __webpack_public_path__ + "static/media/OptiLynx.6f1eb523cbfe97a3072fb14c9bf49feb.svg";
export { ForwardRef as ReactComponent };